export default function ClubRowSkeletonListItem() {
  return (
    <li className="flex justify-between gap-x-6 py-5 animate-pulse">
      <div className="flex min-w-0 gap-x-4 w-full">
        <div className="min-w-0 flex-auto">
          <div className="h-4 w-48 bg-gray-300 rounded"></div>
        </div>
      </div>
      <div className="shrink-0 sm:flex sm:flex-col sm:items-end flex">
        <div className="h-10 w-10 bg-gray-300 rounded"></div>
      </div>
    </li>
  )
}
